/*
 * @Author: your name
 * @Date: 2021-07-08 17:41:56
 * @LastEditTime: 2021-07-13 18:08:50
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \JN010665\src\libs\login.js
 */
import router from "../router";
import store from "../store";
import cookie from "@utils/store/localStorage";
// import { isWeixin } from "@utils";
// import { oAuth } from "@libs/wechat";

export default function toLogin(push, backUrl) {
  store.commit("LOGOUT");
  const { fullPath, name } = router.currentRoute;
  cookie.set("login_back_url", backUrl || fullPath);
  if (name !== "Login") {
    push ? router.push({ path: "/login" }) : router.replace({ path: "/login" });
  }
}
